import { render } from "./Revision.vue?vue&type=template&id=50538c91&scoped=true"
import script from "./Revision.vue?vue&type=script&lang=js"
export * from "./Revision.vue?vue&type=script&lang=js"

import "./Revision.vue?vue&type=style&index=0&id=50538c91&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50538c91"]])

export default __exports__